import React from "react";
import { useTheme } from "../contexts/ThemeContext";

/** Dark: compact header slot. Light: larger logo (same 2∶1 box ratio). */
const DARK_W_PX = 96;
const DARK_H_PX = 48;
const LIGHT_W_PX = 128;
const LIGHT_H_PX = 64;

type NiadLogoProps = {
  alt?: string;
  className?: string;
};

export function NiadLogo({ alt = "NIAD Group.", className = "" }: NiadLogoProps) {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  const src = isDark ? "/logo.png" : "/logo-black.png";

  return (
    <img
      src={src}
      alt={alt}
      width={isDark ? DARK_W_PX : LIGHT_W_PX}
      height={isDark ? DARK_H_PX : LIGHT_H_PX}
      decoding="async"
      className={`shrink-0 object-contain ${isDark ? "h-12 w-24" : "h-16 w-32"} ${className}`.trim()}
    />
  );
}
